import { t } from "@/i18n-js/instance";
import { isCurrent, shouldContactSupport } from "@/react/helpers/plansHelpers";
import type { Plan } from "@circle-react/types";
import {
  type ButtonVariant,
  getButtonTranslationKey,
  getButtonVariant,
} from "./submitHelpers";

export interface ButtonConfig {
  disabled: boolean;
  shouldShowContactSupport: boolean;
  testId: string;
  text: string;
  variant: ButtonVariant;
}

export const useButtonConfig = (plan: Plan): ButtonConfig => {
  const shouldShowContactSupport = shouldContactSupport(plan.plan_action);
  if (shouldShowContactSupport) {
    return {
      disabled: false,
      shouldShowContactSupport: true,
      testId: `submit-button-${plan.plan_action}`,
      text: t("pricing_plans.actions.contact_cx"),
      variant: "secondary",
    };
  }
  const variant = getButtonVariant(plan);
  return {
    disabled: isCurrent(plan.plan_action),
    shouldShowContactSupport: false,
    testId: `submit-button-${plan.plan_action}`,
    text: t(getButtonTranslationKey(plan), {
      plan_name: plan.display_name,
    }),
    variant: variant || "secondary",
  };
};
